import { render, staticRenderFns } from "./add-pet.vue?vue&type=template&id=8de1a13a&scoped=true&lang=pug"
import script from "./add-pet.js?vue&type=script&lang=js&external"
export * from "./add-pet.js?vue&type=script&lang=js&external"
import style0 from "./add-pet.vue?vue&type=style&index=0&id=8de1a13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de1a13a",
  null
  
)

export default component.exports